import { gql } from "@apollo/client";

export const GET_DATOS_PRINCIPALES_BY_ID = gql`
query evaluacionById($idEvaluacion: Int!) {
    evaluacionById(idEvaluacion: $idEvaluacion) {
        evaluacion{
            cliente {
              cod_Ramo
            }
            financiadorParticular
            idCliente
            idClienteSubVenta
            idPaciente
            idPacienteNavigation{
                nombre
                apellido
                codSAPPaciente
                fechaNacimiento
                mail
                sexo
                sinDoc
                responsable
                idTipoDocumento
                numeroDocumento
                telefonoContacto
                familiar
                familiarTelefono
            }
            idEstadoEvaluacionNavigation{
                descripcion
            }
            medicoContacto
            telefonoMedicoContacto
            numeroAfiliado
            fechaAlta
            idLugarServicio
            idinstitucion
            idDerivador
            idDerivadorExterno
            tipoDerivador
            derivadorOS
            idTipoModulo
            idCentroReferencia
            codigoDiagnosticoTraditum
            prestadorPrescriptor
            identificadorPrestadorPrescriptor
            observaciones
            idCanal
            detalleCanal
            idPrePaciente
            idPrePacienteNavigation{
                observacion
            }
        }
        derivacionPrescriptor{
            idArchivo
            contentType
            titulo
            archivo
            extension
            fechaAlta
        }
    }
}`;

function safeParse(value) {
  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  }

  return value;
}

export const adaptGetDatosPrincipales = (datosPrincipales) => {
  const { evaluacion, derivacionPrescriptor } = datosPrincipales?.evaluacionById || {};

  return {
    codigoRamoCliente: evaluacion?.cliente?.cod_Ramo,
    financiadorParticular: safeParse(evaluacion?.financiadorParticular),
    idPaciente: evaluacion?.idPaciente,
    idCliente: evaluacion?.idCliente,
    idClienteSubVenta: evaluacion?.idClienteSubVenta,
    nombre: evaluacion?.idPacienteNavigation?.nombre,
    apellido: evaluacion?.idPacienteNavigation?.apellido,
    codSAPPaciente: evaluacion?.idPacienteNavigation?.codSAPPaciente,
    mail: evaluacion?.idPacienteNavigation?.mail,
    fechaNacimiento: evaluacion?.idPacienteNavigation?.fechaNacimiento,
    fechaAlta: evaluacion?.fechaAlta,
    sexo: evaluacion?.idPacienteNavigation?.sexo,
    sinDoc: evaluacion?.idPacienteNavigation?.sinDoc,
    responsable: evaluacion?.idPacienteNavigation?.responsable,
    idTipoDocumento: evaluacion?.idPacienteNavigation?.idTipoDocumento,
    numeroDocumento: evaluacion?.idPacienteNavigation?.numeroDocumento,
    numeroAfiliado: evaluacion?.numeroAfiliado,
    idLugarServicio: evaluacion?.idLugarServicio,
    idInstitucion: evaluacion?.idinstitucion,
    sinInstitucion: evaluacion?.idCliente && !evaluacion?.financiadorParticular && !evaluacion?.idinstitucion,
    idDerivador: evaluacion?.idDerivador,
    idDerivadorExterno: evaluacion?.idDerivadorExterno,
    tipoDerivador: evaluacion?.tipoDerivador,
    derivadorOS: evaluacion?.derivadorOS,
    fechaAltaRP: derivacionPrescriptor?.fechaAlta,
    idTipoModulo: evaluacion?.idTipoModulo,
    idCentroReferencia: evaluacion?.idCentroReferencia,
    codigoDiagnosticoTraditum: evaluacion?.codigoDiagnosticoTraditum,
    prestadorPrescriptor: evaluacion?.prestadorPrescriptor,
    identificadorPrestadorPrescriptor: evaluacion?.identificadorPrestadorPrescriptor,
    medicoContacto: evaluacion?.medicoContacto,
    telefonoMedicoContacto: evaluacion?.telefonoMedicoContacto,
    telefonoContacto: evaluacion?.idPacienteNavigation?.telefonoContacto,
    familiar: evaluacion?.idPacienteNavigation?.familiar,
    familiarTelefono: evaluacion?.idPacienteNavigation?.familiarTelefono,
    observaciones: evaluacion?.observaciones,
    idCanal: evaluacion?.idCanal,
    detalleCanal: evaluacion?.detalleCanal,
    idPrePaciente: evaluacion?.idPrePaciente,
    observacionPrePaciente: evaluacion?.idPrePacienteNavigation?.observacion,
    derivacionPrescriptor: !derivacionPrescriptor ? null : {
      idArchivo: derivacionPrescriptor?.idArchivo,
      contentType: derivacionPrescriptor?.contentType,
      titulo: derivacionPrescriptor?.titulo,
      archivo: derivacionPrescriptor?.archivo,
      extension: derivacionPrescriptor?.extension
    }
  };
};